module.exports = __webpack_public_path__ + "static/media/a35.5ba7e2f9.jpg";